<section class="ups-package-planner">
  <div class="ups-package-planner__header" *ngIf="!disabled">
    <p class="ups-package-planner__hint">{{ "printCardOrders.shipmentPackages.hint" | translate }}</p>
    <button mat-stroked-button type="button" tabindex="-1" (click)="addPackage()" [disabled]="disabled">
      {{ "printCardOrders.shipmentPackages.addPackage" | translate }}
    </button>
  </div>

  <div
    class="ups-package-planner__layout"
    [class.ups-package-planner__layout--packages-only]="disabled && !showUnassignedPool"
  >
    <div class="ups-package-planner__pool card-panel" *ngIf="showUnassignedPool">
      <div class="ups-package-planner__pool-header">
        <h4>{{ "printCardOrders.shipmentPackages.unassignedTitle" | translate }}</h4>
        <div class="ups-package-planner__pool-actions" *ngIf="!disabled">
          <button
            mat-icon-button
            type="button"
            tabindex="-1"
            (click)="resetPackaging()"
            [disabled]="disabled || !canResetPackaging"
            [attr.aria-label]="'printCardOrders.shipmentPackages.resetPacking' | translate"
            [matTooltip]="'printCardOrders.shipmentPackages.resetPacking' | translate"
          >
            <mat-icon>restart_alt</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            tabindex="-1"
            (click)="autoArrange.emit()"
            [attr.aria-label]="'printCardOrders.shipmentPackages.autoArrange' | translate"
            [matTooltip]="'printCardOrders.shipmentPackages.autoArrange' | translate"
          >
            <mat-icon>auto_awesome</mat-icon>
          </button>
        </div>
      </div>

      <div
        *ngIf="disabled"
        class="ups-package-planner__dropzone ups-package-planner__dropzone--readonly"
      >
        <ng-container *ngFor="let item of unassignedItems">
          <ng-container
            *ngTemplateOutlet="unassignedChip; context: { item: item }"
          ></ng-container>
        </ng-container>
        <p class="ups-package-planner__empty" *ngIf="showAllAssignedMessage">
          {{ "printCardOrders.shipmentPackages.allAssigned" | translate }}
        </p>
      </div>

      <div
        *ngIf="!disabled"
        class="ups-package-planner__dropzone"
        cdkDropList
        [id]="unassignedDropListId"
        [cdkDropListData]="unassignedItems"
        [cdkDropListConnectedTo]="packageDropListIds"
        (cdkDropListDropped)="onDrop($event)"
      >
        <div
          class="ups-package-planner__chip"
          [class.ups-package-planner__chip--locked]="isItemUnassignable(item)"
          *ngFor="let item of unassignedItems"
          cdkDrag
          [cdkDragData]="item"
          [cdkDragDisabled]="isItemUnassignable(item)"
        >
          <ng-container
            *ngTemplateOutlet="unassignedChipBody; context: { item: item }"
          ></ng-container>
          <div
            *cdkDragPreview
            class="ups-package-planner__chip ups-package-planner__chip--preview"
          >
            <strong>#{{ item.printerOrderNumber }}</strong>
          </div>
        </div>
        <p class="ups-package-planner__empty" *ngIf="showAllAssignedMessage">
          {{ "printCardOrders.shipmentPackages.allAssigned" | translate }}
        </p>
      </div>
    </div>

    <div class="ups-package-planner__packages">
      <article class="ups-package-planner__package card-panel" *ngFor="let pkg of packages; let index = index; trackBy: trackPackageById">
        <div class="ups-package-planner__package-header">
          <h4>{{ "printCardOrders.shipmentPackages.packageTitle" | translate : { index: index + 1 } }}</h4>
          <button
            mat-icon-button
            type="button"
            tabindex="-1"
            *ngIf="!disabled"
            (click)="removePackage(pkg.id)"
            [disabled]="disabled || packages.length <= 1"
            [attr.aria-label]="'printCardOrders.shipmentPackages.removePackage' | translate"
          >
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>

        <div
          class="ups-package-planner__dropzone ups-package-planner__dropzone--package"
          [class.ups-package-planner__dropzone--locked]="disabled"
          cdkDropList
          [id]="dropListId(pkg.id)"
          [cdkDropListData]="itemsForPackage(pkg)"
          [cdkDropListConnectedTo]="connectedDropLists(pkg.id)"
          [cdkDropListDisabled]="disabled"
          (cdkDropListDropped)="onDrop($event, pkg.id)"
        >
          <div
            class="ups-package-planner__chip"
            *ngFor="let item of itemsForPackage(pkg)"
            cdkDrag
            [cdkDragData]="item"
            [cdkDragDisabled]="disabled"
          >
            <ng-container
              *ngTemplateOutlet="packageChipBody; context: { item: item }"
            ></ng-container>
            <div
              *cdkDragPreview
              class="ups-package-planner__chip ups-package-planner__chip--preview"
            >
              <strong>#{{ item.printerOrderNumber }}</strong>
            </div>
          </div>
          <p class="ups-package-planner__empty" *ngIf="itemsForPackage(pkg).length === 0">
            {{ "printCardOrders.shipmentPackages.dropHere" | translate }}
          </p>
        </div>

        <div class="ups-package-planner__fields">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.packageWeight" | translate }}</mat-label>
            <input
              matInput
              type="number"
              step="0.01"
              min="0.01"
              [value]="pkg.packageWeight"
              (change)="updatePackageField(pkg.id, 'packageWeight', +$any($event.target).value)"
              [disabled]="disabled"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.packageLength" | translate }}</mat-label>
            <input
              matInput
              type="number"
              step="0.1"
              min="0.1"
              [value]="pkg.packageLength"
              (change)="updatePackageField(pkg.id, 'packageLength', +$any($event.target).value)"
              [disabled]="disabled"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.packageWidth" | translate }}</mat-label>
            <input
              matInput
              type="number"
              step="0.1"
              min="0.1"
              [value]="pkg.packageWidth"
              (change)="updatePackageField(pkg.id, 'packageWidth', +$any($event.target).value)"
              [disabled]="disabled"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ "printCardOrders.shipment.packageHeight" | translate }}</mat-label>
            <input
              matInput
              type="number"
              step="0.1"
              min="0.1"
              [value]="pkg.packageHeight"
              (change)="updatePackageField(pkg.id, 'packageHeight', +$any($event.target).value)"
              [disabled]="disabled"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
            <mat-label>{{ "printCardOrders.shipment.packageDescription" | translate }}</mat-label>
            <input
              matInput
              maxlength="35"
              [value]="pkg.packageDescription"
              (change)="updatePackageField(pkg.id, 'packageDescription', $any($event.target).value)"
              [disabled]="disabled"
            />
          </mat-form-field>
        </div>
      </article>
    </div>
  </div>

  <p class="ups-package-planner__validation" *ngIf="!disabled && !isValid()">
    {{ "printCardOrders.shipmentPackages.validation" | translate }}
  </p>

  <mat-menu #moveMenu="matMenu">
    <button
      mat-menu-item
      type="button"
      *ngFor="let target of moveMenuTargets"
      (click)="selectMoveTarget(target.id)"
    >
      {{ "printCardOrders.shipmentPackages.moveToPackageOption" | translate : { index: target.index } }}
    </button>
  </mat-menu>
</section>

<ng-template #unassignedChip let-item="item">
  <div
    class="ups-package-planner__chip"
    [class.ups-package-planner__chip--locked]="isItemUnassignable(item)"
  >
    <ng-container
      *ngTemplateOutlet="unassignedChipBody; context: { item: item }"
    ></ng-container>
  </div>
</ng-template>

<ng-template #unassignedChipBody let-item="item">
  <div class="ups-package-planner__chip-drag" cdkDragHandle>
    <div class="ups-package-planner__chip-header">
      <strong>#{{ item.printerOrderNumber }}</strong>
    </div>
    <span class="ups-package-planner__chip-type">
      {{ templateTypeLabelKey(item.templateType) | translate }}
    </span>
    <span *ngIf="item.employeeName" class="ups-package-planner__chip-name">
      {{ item.employeeName }}
    </span>
    <span>{{ item.templateName }}</span>
    <span>{{ item.quantity }} {{ "printCardOrders.quantityUnit" | translate }}</span>
    <span
      *ngIf="isItemFulfillmentBlocked(item)"
      class="ups-package-planner__chip-lock"
      [matTooltip]="
        'printCardOrders.fulfillmentBlocked.EMPLOYEE_DELETED_tooltip'
          | translate
            : {
                employeeName: item.employeeName || item.employeeEmail,
                employeeEmail: item.employeeEmail
              }
      "
      matTooltipPosition="above"
    >
      <mat-icon>block</mat-icon>
      {{ "printCardOrders.fulfillmentBlocked.EMPLOYEE_DELETED_tag" | translate }}
    </span>
    <span *ngIf="isItemLocked(item)" class="ups-package-planner__chip-lock">
      <mat-icon>lock</mat-icon>
      {{ "printCardOrders.shipmentPackages.nfcLocked" | translate }}
    </span>
  </div>
  <div class="ups-package-planner__chip-actions">
    <button
      mat-icon-button
      type="button"
      tabindex="-1"
      class="ups-package-planner__chip-action"
      *ngIf="canPreviewItem(item)"
      (click)="onPreviewItem(item, $event)"
      [attr.aria-label]="'printCardOrders.previewItem' | translate"
      [matTooltip]="'printCardOrders.previewItem' | translate"
    >
      <mat-icon>visibility</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      tabindex="-1"
      class="ups-package-planner__chip-action"
      *ngIf="!disabled && !isItemUnassignable(item) && packageTargetsForItem(item).length > 0"
      [matMenuTriggerFor]="moveMenu"
      (mousedown)="openMoveMenu(item, $event)"
      [attr.aria-label]="'printCardOrders.shipmentPackages.moveToPackage' | translate"
      [matTooltip]="'printCardOrders.shipmentPackages.moveToPackage' | translate"
    >
      <mat-icon>drive_file_move</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #packageChipBody let-item="item">
  <div class="ups-package-planner__chip-drag" cdkDragHandle>
    <div class="ups-package-planner__chip-header">
      <strong>#{{ item.printerOrderNumber }}</strong>
    </div>
    <span class="ups-package-planner__chip-type">
      {{ templateTypeLabelKey(item.templateType) | translate }}
    </span>
    <span *ngIf="item.employeeName" class="ups-package-planner__chip-name">
      {{ item.employeeName }}
    </span>
    <span>{{ item.templateName }}</span>
    <span>{{ item.quantity }} {{ "printCardOrders.quantityUnit" | translate }}</span>
  </div>
  <div class="ups-package-planner__chip-actions" *ngIf="!disabled || canPreviewItem(item)">
    <button
      mat-icon-button
      type="button"
      tabindex="-1"
      class="ups-package-planner__chip-action"
      *ngIf="canPreviewItem(item)"
      (click)="onPreviewItem(item, $event)"
      [attr.aria-label]="'printCardOrders.previewItem' | translate"
      [matTooltip]="'printCardOrders.previewItem' | translate"
    >
      <mat-icon>visibility</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      tabindex="-1"
      class="ups-package-planner__chip-action"
      *ngIf="!disabled && packageTargetsForItem(item).length > 0"
      [matMenuTriggerFor]="moveMenu"
      (mousedown)="openMoveMenu(item, $event)"
      [attr.aria-label]="'printCardOrders.shipmentPackages.moveToPackage' | translate"
      [matTooltip]="'printCardOrders.shipmentPackages.moveToPackage' | translate"
    >
      <mat-icon>drive_file_move</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      tabindex="-1"
      class="ups-package-planner__chip-action"
      *ngIf="!disabled"
      (click)="unassignItem(item, $event)"
      [attr.aria-label]="'printCardOrders.shipmentPackages.removeFromPackage' | translate"
      [matTooltip]="'printCardOrders.shipmentPackages.removeFromPackage' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-template>
